export function mapArticleFromDto(dto) {
    return {
        id: dto.id,
        title: dto.title,
        description: dto.teaser,
        content: dto.content,
    };
}
